(function () {
  'use strict';

  if (window.LAOptionalClarityFixInstalled) return;
  window.LAOptionalClarityFixInstalled = true;

  function noop() {}

  function text(value) {
    return String(value == null ? '' : value).trim();
  }

  function carat(value) {
    var match = text(value).replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  }

  function currentRingVariant(form, data) {
    var input = form.querySelector('select[name="id"], input[name="id"]');
    if (!input || !data.ring || !Array.isArray(data.ring.variants)) return null;
    return data.ring.variants.find(function (variant) {
      return String(variant.id) === String(input.value);
    }) || null;
  }

  function ringCaratDetails(data, variant) {
    if (!data.ring || !Array.isArray(data.ring.options) || !variant || !Array.isArray(variant.options)) return null;
    var index = data.ring.options.findIndex(function (name) {
      return /centre stone|center stone|carat weight|carat/i.test(name);
    });
    if (index < 0) index = 0;
    var label = text(variant.options[index]);
    var value = carat(label);
    return value === null ? null : {label: label, value: value};
  }

  function prepareStandardClarity(form) {
    if (!form || !form.querySelector) return noop;

    var dataElement = form.querySelector('[data-la-personalise] [data-la-data]');
    if (!dataElement) return noop;

    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return noop;
    }

    if (!data.clarity || !Array.isArray(data.clarity.variants) || !data.clarity.variants.length) return noop;
    if (!data.clarity.variants.some(function (variant) { return text(variant.clarity).toUpperCase() === 'VS1'; })) return noop;

    var ringVariant = currentRingVariant(form, data);
    var ringCarat = ringCaratDetails(data, ringVariant);
    if (!ringVariant || !ringCarat) return noop;

    var configuredMatches = data.clarity.variants.filter(function (variant) {
      return carat(variant.carat) === ringCarat.value;
    });
    if (configuredMatches.length) return noop;

    var row = form.querySelector('[data-la-personalise] [data-la-row="clarity"]');
    var options = row && row.querySelector('[data-la-options="clarity"], [data-la-options]');
    if (!row || !options) return noop;

    var originalData = dataElement.textContent;
    var originalHidden = row.hidden;
    var originalDisplay = row.style.display;
    var originalAriaHidden = row.getAttribute('aria-hidden');
    var originalChildren = Array.prototype.slice.call(options.childNodes);

    var purchaseData = JSON.parse(JSON.stringify(data));
    purchaseData.clarity.variants.push({
      id: 1,
      carat: ringCarat.label,
      clarity: 'VS1',
      price: 0,
      available: true,
      synthetic: true
    });
    dataElement.textContent = JSON.stringify(purchaseData);

    row.hidden = false;
    row.style.display = 'none';
    row.setAttribute('aria-hidden', 'true');

    while (options.firstChild) options.removeChild(options.firstChild);
    var standard = document.createElement('button');
    standard.type = 'button';
    standard.className = 'la-choice is-selected';
    standard.textContent = 'VS1';
    standard.tabIndex = -1;
    standard.setAttribute('aria-hidden', 'true');
    options.appendChild(standard);

    return function restore() {
      dataElement.textContent = originalData;
      row.hidden = originalHidden;
      row.style.display = originalDisplay;
      if (originalAriaHidden === null) row.removeAttribute('aria-hidden');
      else row.setAttribute('aria-hidden', originalAriaHidden);
      while (options.firstChild) options.removeChild(options.firstChild);
      originalChildren.forEach(function (child) { options.appendChild(child); });
    };
  }

  function install() {
    var purchase = window.LAUpgradePurchase;
    if (!purchase || typeof purchase.add !== 'function') return false;
    if (purchase.add.laOptionalClarityFix) return true;

    var originalAdd = purchase.add;
    var wrappedAdd = async function (form, button) {
      var restore = prepareStandardClarity(form);
      try {
        return await originalAdd.call(purchase, form, button);
      } finally {
        restore();
      }
    };
    wrappedAdd.laOptionalClarityFix = true;
    purchase.add = wrappedAdd;
    return true;
  }

  if (!install()) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (install() || attempts >= 100) window.clearInterval(timer);
    }, 50);
  }
})();